/**
 * How long until an auction closes — `W6-T06`. **Decoration**: the server's clock decides
 * (`agent-auctions`: *"the countdown UI is decorative"*). `now` comes from the loader, so a render
 * is a pure function of its data and the 5-second poll moves it on.
 */
export interface TimeLeft {
  readonly days: number;
  readonly hours: number;
  readonly minutes: number;
}

/** `null` once the deadline has passed. Minutes round up: "0 minutes left" while open is a lie. */
export function timeLeft(closesAt: string, now: string): TimeLeft | null {
  const ms = new Date(closesAt).getTime() - new Date(now).getTime();
  if (ms <= 0) return null;
  const totalMinutes = Math.ceil(ms / 60_000);
  return {
    days: Math.floor(totalMinutes / 1440),
    hours: Math.floor((totalMinutes % 1440) / 60),
    minutes: totalMinutes % 60,
  };
}
